module.exports = __webpack_public_path__ + "static/media/Clock.fc690b94.png";